import { render, staticRenderFns } from "./ReportEvent.vue?vue&type=template&id=703355d4&scoped=true&"
import script from "./ReportEvent.vue?vue&type=script&lang=js&"
export * from "./ReportEvent.vue?vue&type=script&lang=js&"
import style0 from "./ReportEvent.vue?vue&type=style&index=0&id=703355d4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703355d4",
  null
  
)

export default component.exports